module.exports = __webpack_public_path__ + "img/ge.2c4e46e1.svg";